"use client";

import type React from "react";
import { createContext, useContext } from "react";
import type { AuthState } from "shared/UtilTypes";

export interface AuthContextState {
  authState: AuthState | undefined;
}

export interface AuthActions {
  signIn: (authState: AuthState) => Promise<void>;
  setAuthState: React.Dispatch<React.SetStateAction<AuthState | undefined>>;
}

export type AuthContextType = AuthContextState & AuthActions;

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

/** Like useAuth, but returns undefined outside an AuthProvider, e.g. on public docs pages. */
export const useOptionalAuth = () => useContext(AuthContext);
